import { OvrProjectsState } from './ovrProjectsSlice';

// Conversion layer: converts frontend state to API parameters
export const buildParams = (state: OvrProjectsState) => ({
  _limit: state.pageSize,
  _order_by: state.sort || 'updated_at:desc',
  _columns: '*,client.*,createdByUser.*',
  _offset: (state.page - 1) * state.pageSize,
  status: 'active',
  ...(state.search ? { name: `*${state.search.toLowerCase()}*` } : {}),
});

// convert params to query string
export const toQueryString = (params: Record<string, any>) => {
  const usp = new URLSearchParams();

  ['page', 'pageSize', 'search', 'sort'].forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      usp.set(key, String(value));
    }
  });

  return usp.toString();
};
